import React from 'react';

import { WizardCard } from 'src/app/components/lib/wizard/card';
import { LD } from 'src/app/constants/launch-darkly-flags';
import { useLDFlag } from 'src/app/hooks/use-ld-flag';

import { defaultSpecialCard } from '../../constants';
import { useDiscountWizardStateContext } from '../../state';

import { GamificationCard } from './gamification/gamification-card';
import {
  DescriptionWithGamification,
  IndividualSpecialPreviewTextContainer,
  Preview,
  PreviewDescription,
  PreviewSection,
  PreviewSectionTitle,
  PreviewTitle,
  SpecialsCardContainer,
  SpecialsCardShopButton,
} from './styled';

const DEFAULT_DESCRIPTION =
  'This preview shows what your discount will look like on your specials home page and individual specials page.';

const DESCRIPTION_WITH_GAMIFICATION = (
  <DescriptionWithGamification>
    <div>
      This preview shows what your discount will look like on your specials home page, individual specials page and if
      applicable, how the special offer tracking will display
    </div>
    <div>
      Special Offer Tracking - this feature helps users awareness of special offers and displays progress towards
      completion.
    </div>
  </DescriptionWithGamification>
);

export function PreviewCard() {
  const isGamificationPreviewEnabled = useLDFlag(LD.DISCOUNT_WIZARD_GAMIFICATION, false);
  const {
    onlineDetailsStepState: { description, imageUrl, onlineName },
  } = useDiscountWizardStateContext();

  const previewDescription = isGamificationPreviewEnabled ? DESCRIPTION_WITH_GAMIFICATION : DEFAULT_DESCRIPTION;

  return (
    <WizardCard description={previewDescription} title='Preview' titleSize={18}>
      <Preview>
        <PreviewSection>
          <PreviewSectionTitle>Individual specials page</PreviewSectionTitle>
          <IndividualSpecialPreviewTextContainer $imageUrl={getImageUrl(imageUrl)}>
            <PreviewTitle>{onlineName}</PreviewTitle>
            {description !== '' && <PreviewDescription>{description}</PreviewDescription>}
          </IndividualSpecialPreviewTextContainer>
        </PreviewSection>
        <PreviewSection>
          <PreviewSectionTitle>Specials homepage</PreviewSectionTitle>
          <SpecialsCardContainer $imageUrl={getImageUrl(imageUrl)}>
            <PreviewTitle>{onlineName}</PreviewTitle>
            <SpecialsCardShopButton>Shop</SpecialsCardShopButton>
          </SpecialsCardContainer>
        </PreviewSection>
        {isGamificationPreviewEnabled && <GamificationCard />}
      </Preview>
    </WizardCard>
  );
}

export function getImageUrl(imageUrl: string | undefined) {
  if (!imageUrl || imageUrl === '') {
    return defaultSpecialCard;
  }
  return imageUrl;
}
